// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type {
  IComponentDataGuestCalendarRequest,
  TComponentDataGuestCalendarModel,
  IMappers,
  TComponentDataGuestCalendarResponse,
} from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IV1ComponentDataGuestCalendarResponse } from '../../../entities/response/V1ComponentDataGuestCalendarResponse';
import type { IErrorResponseSchema } from '../../../entities/schemas/ErrorResponseSchema';

export function createComponentDataGuestCalendarModel(
  parameters: IComponentDataGuestCalendarRequest,
): TComponentDataGuestCalendarModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'GET',
    microserviceName: 'dailyrent',
    pathApi: '/v1/component-data/guest-calendar/',
    response: {
      200: {
        contentType: 'json',
      },
      400: {
        contentType: 'json',
      },
    },
    request: {
      parameters,
    },
  };
}

export interface IComponentDataGuestCalendarOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IComponentDataGuestCalendarRequest;
}

export async function fetchComponentDataGuestCalendar<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IComponentDataGuestCalendarOptions<TResponse200, TResponse400>): Promise<
  FetchResponse<TComponentDataGuestCalendarResponse> | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createComponentDataGuestCalendarModel(parameters),
    config,
  )) as FetchResponse<TComponentDataGuestCalendarResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IV1ComponentDataGuestCalendarResponse, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TComponentDataGuestCalendarResponse>;
}
